export default __webpack_public_path__ + "static/media/IRP.f61a075f.svg";